import { permissionEngine } from '@/core/permissions/permissionEngine';
import { useAuth } from '@/core/auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useRequestsNew } from './hooks/useRequestsNew';
import { AIChatDrawer } from './components/AIChatDrawer';
import { PageHeaderNew } from '@/components/ui';
import { StepIndicator } from './components/form/StepIndicator';
import { GeneralInfoSection } from './components/form/GeneralInfoSection';
import { SummaryContentSection } from './components/form/SummaryContentSection';
import { SideInfoPanel } from './components/form/SideInfoPanel';
import { StickyFooterActions } from './components/form/StickyFooterActions';

export function RequestNewPage() {
  const { profile } = useAuth();
  permissionEngine.assert(profile?.id || '', 'requests.create');
  const navigate = useNavigate();

  const {
    formData,
    setFormData,
    projects,
    zones,
    proposalGroups,
    proposalCategories,
    proposalPurposes,
    approvers,
    isSaving,
    createRequest,
    isChatOpen,
    setIsChatOpen,
    applyAIData
  } = useRequestsNew();
  
  return (
    <div className="mx-auto flex flex-col pb-20 w-full max-w-[1400px] bg-white min-h-screen px-4 sm:px-8 pt-6">
      <PageHeaderNew 
        title="Tạo đề xuất"
        subtitle="Tạo mới đề xuất cho công việc thi công hoặc bảo dưỡng"
        backUrl="/requests"
      />

      <StepIndicator 
        currentStep={1} 
        onAISparkleClick={() => setIsChatOpen(true)} 
      />

      <div className="grid grid-cols-1 gap-12 xl:grid-cols-[1fr_400px]">
        {/* Left Column - Main Form */}
        <div className="flex flex-col gap-10">
          <GeneralInfoSection 
            formData={formData}
            setFormData={setFormData}
            projects={projects}
            zones={zones}
            approvers={approvers}
            profile={profile}
          />

          <SummaryContentSection 
            formData={formData}
            setFormData={setFormData}
          />
        </div>

        {/* Right Column - Sidebars */}
        <SideInfoPanel 
          formData={formData}
          setFormData={setFormData}
          projects={projects}
          zones={zones}
          proposalGroups={proposalGroups}
          proposalCategories={proposalCategories}
          proposalPurposes={proposalPurposes}
          profile={profile}
        />
      </div>

      <div className="h-20"></div>

      <StickyFooterActions 
        isSaving={isSaving}
        onCancel={() => navigate('/requests')}
        onConfirm={createRequest}
      />

      <AIChatDrawer 
        isOpen={isChatOpen}
        onClose={() => setIsChatOpen(false)}
        onApply={applyAIData}
      />
    </div>
  );
}

export default RequestNewPage;
